
import Vue from 'vue';
import {
  mapGetters, mapMutations, mapState,
} from 'vuex';
import Heading from '@/components/Heading/index.vue';
import Button from '@/components/Button/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import ResultSearch from '@/components/ResultSearch/index.vue';
import NotificationCenter from '@/components/NotificationCenter/index.vue';
import CustomTable from '@/components/Table/index.vue';
import oauthToken from '@/services/oauth/post-tmx-oauth';
import getTerritoryByAgentDocumentService, { TerritoryStatus } from '@/services/territory/get-territory-by-agent-document';
import { NotificationResponseType, responseNotification, ResponseNotificationParams } from '@/services/notifications/response-notification';
import responsePath from '@/services/territory-access/response';
import {
  StatusTerritoryAccess,
  ResponseInfo,
} from '@/config/types';
import {
  getUserGroup,
  formatStringOnlyNumbers,
} from '@/utils';
import Footer from '@/components/Footer/index.vue';
import Header from '@/components/Header/index.vue';
import { getReadNotification } from '@/services/notifications/get-read-notification';
import { insertReadNotification } from '@/services/notifications/insert-read-notification';
import getCalculateTicket from '@/services/tickets/get-tickets-total';
import ResultSearchFinancial from '@/components/ResultSearchFinancial/index.vue';
import { Label } from '@/components/ResultSearchFinancial/styles';
import { getContestation } from '@/services/contestation/get-contestationPaginate';
import Tab from '@/components/NavTab/index.vue';
import Tabs from '@/components/NavTabs/index.vue';
import Dashboard from './Dashboard/index.vue';
import Territory from './Territory/index.vue';
import Contestation from './Constestation/index.vue';
import Financial from './Financial/index.vue';
import {
  CountLabel, Headerinline, HeadCollumn,
} from './styles';

export default Vue.extend({
  components: {
    Dashboard,
    Territory,
    Tabs,
    Tab,
    Contestation,
    Financial,
    Footer,
    Header,
    CountLabel,
    CustomTable,
    Heading,
    ResultMessage,
    ResultSearch,
    Button,
    Headerinline,
    ResultSearchFinancial,
    HeadCollumn,
    Label,
    NotificationCenter,
  },
  data() {
    return {
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      routes: [
        { path: '/admin', name: 'Dashboard' },
        { path: '/admin/territories', name: 'Monitoramento de territórios cadastrados' },
      ],
      digitalSafe: '',
      loaded: false as boolean,
      loading: false as boolean,
      isHome: true,
      pagination: {} as any,
      territories: {} as any,
      isLoading: false,
      territory: [] as any[],
      notifications: [] as any[],
      openNotificationCenter: false,
      inputSearch: '',
      userType: '',
      results: null,
      resultsFinancial: [{}],
      document: '',
      resultsMonitoring: [{}],
      dataMonitoring: [{}],
      reloadCondition: false,
      tickets: {} as any,
      isReadObj: [] as any,
      isReadData: {} as any,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      objTerritory: [{
        name: '',
        id: '',
        amountTotal: '',
        amountPaid: '',
        split: '',
        statusofPayment: '',
        status: 'Em dia',
      }] as any,
    };
  },
  computed: {
    ...mapState(['appointments']),
    ...mapGetters(['notificationData', 'getNotifications', 'getAppointment', 'DateById', 'Link']),
  },
  methods: {
    ...mapMutations(['setNotification']),
    async getTerritoriesRequest() {
      const tokenKey = this.userLoged.company.stKey;
      const response = await getContestation(10, 1, tokenKey);
      response.forEach((j) => {
        if (this.isReadObj.filter((i) => i.cdTerritory === j.cdTerritory).length > 0) {
          this.notifications.push({
            id: j.cdTerritory,
            name: j.name,
            viewed: true,
            time: j.createdOn.slice(0, -16).split('-').reverse().join('-')
              .replaceAll('-', '/'),
            idTerritory: j.id,
            text: `O produtor do Território ${j.name}, Contestou as detecções!`,
            type: 'info',
            tag: 'Contestação',
            url: 'teste.com',
          });
        } else {
          this.notifications.push({
            id: j.cdTerritory,
            name: j.name,
            viewed: false,
            time: j.createdOn.slice(0, -16).split('-').reverse().join('-')
              .replaceAll('-', '/'),
            idTerritory: j.id,
            text: `O produtor do Território ${j.name}, Contestou as detecções!`,
            type: 'info',
            tag: 'Contestação',
            url: 'teste.com',
          });
        }
      });
      // const response = await getAllTerritories(params);
      this.territories = response?.results || [];
      this.pagination.total = response?.rowCount || 0;
      this.loading = false;
    },
    goToDetails(id: number, name: string) {
      this.$router.push(`admin/territorio/${id}/${name}`);
    },
    handleOpenNotificationCenter() {
      this.openNotificationCenter = !this.openNotificationCenter;
    },
    async monitoring(value: string) {
      this.loaded = false;
      this.isLoading = true;
      const formattedValue = formatStringOnlyNumbers(value);
      this.$router.push({ query: { financial: formattedValue } });
      this.resultsFinancial = await getTerritoryByAgentDocumentService(formattedValue, '', TerritoryStatus.provisional, false);
      this.resultsFinancial.forEach((e: any) => {
        getCalculateTicket({ cdTerritory: e.id }).then();
        getCalculateTicket({ cdTerritory: e.id }).then((k) => {
          this.objTerritory.push({
            name: e.agents[0]?.name,
            id: e.id,
            amountTotal: k.objectResult[0].totalAmount,
            amountPaid: k.objectResult[0].amountPaidByTerritory === '' ? 0 : k.objectResult[0].amountPaidByTerritory,
            split: k.objectResult.length,
            statusofPayment: k.objectResult[0].paymentPayed === '' ? 0 : k.objectResult[0].paymentPayed,
            status: k.objectResult[0].statusItem === 'Atrasado' ? 'Pagamento Pendente' : 'Em dia',
          });
        });
        this.objTerritory.splice(0, 1);
        this.results = [] as any;
      });
      this.inputSearch = value;
      this.isHome = false;
      this.loaded = true;
    },
    async search(value: string) {
      this.reloadCondition = true;
      this.document = value;
      this.loaded = false;
      const formattedValue = formatStringOnlyNumbers(value);
      this.$router.push({ query: { agent: formattedValue } });
      this.results = await getTerritoryByAgentDocumentService(formattedValue, '', TerritoryStatus.provisional, false);
      this.inputSearch = value;
      this.isHome = false;
      this.loaded = true;
    },
    async onSetReadNotification(notification: any) {
      const foundNotification = this.notifications.find((n: any) => n.id === notification.id);
      const { idUser } = this.userLoged;
      const tokenKey = this.userLoged.company.stKey;
      const cdTerritory = foundNotification.id;
      await insertReadNotification(idUser, cdTerritory, tokenKey, true, '', '');
      this.$router.push(`admin/territorioInfo/${notification.idTerritory}`);
    },
    onAcceptNotification(notification: any) {
      const { notifications } = this.$store.state;

      const result = notifications.map((n: any) => {
        if (n.id === notification.id) {
          const params: ResponseNotificationParams = {
            notificationId: n.id,
            userId: n.userId,
            notificationType: NotificationResponseType.Granted,
            tokenKey: this.userLoged.company.stKey,
          };

          responseNotification(params);

          return { ...n, read: true, status: NotificationResponseType.Granted };
        }
        return n;
      });
      this.$store.state.notifications = result;
    },
    onRefuseNotification(notification: any) {
      const { notifications } = this.$store.state;

      const result = notifications.map((n: any) => {
        if (n.id === notification.id) {
          const paramsResponse: ResponseInfo = {
            frigId: n.userId,
            territoryId: n.id,
            status: StatusTerritoryAccess.denied,
            tokenKey: this.userLoged.company.stKey,
          };
          responsePath(paramsResponse);
          // responseNotification(params);

          return { ...n, read: true, status: NotificationResponseType.Denied };
        }
        return n;
      });
      this.$store.state.notifications = result;
    },
  },
  async mounted() {
    const { idUser } = this.userLoged;
    await oauthToken();
    const data = await getReadNotification(idUser);
    const reduced = [] as any;
    data.objectResult.forEach((item: any) => {
      const duplicated = reduced.findIndex((redItem: any) => item.cdTerritory === redItem.cdTerritory) > -1;
      if (!duplicated) {
        reduced.push(item);
      }
    });
    this.isReadObj = reduced;
    this.getTerritoriesRequest();
    this.userType = `${getUserGroup()}`;
  },
  watch: {
    results() {
      if (this.results !== null) {
        this.reloadCondition = false;
      }
    },
  },
});
